module.exports = __webpack_public_path__ + "img/i_zip.200e12e1.svg";